import { getAuth } from 'firebase/auth'

/**
 * Retrieves the current user's ID token, refreshing it if needed.
 * Ensures Firebase Auth state has resolved first.
 */
export const getIdToken = async (): Promise<string> => {
  const auth = getAuth()
  const user = auth.currentUser

  if (!user) {
    // Wait for auth state to resolve (especially on reload)
    return new Promise((resolve, reject) => {
      const unsubscribe = auth.onAuthStateChanged(async (user) => {
        unsubscribe()
        if (!user) return reject(new Error('User not authenticated'))
        const token = await user.getIdToken()
        resolve(token)
      })
    })
  }

  return await user.getIdToken()
}
